import { render, staticRenderFns } from "./ProductCombos.vue?vue&type=template&id=58ce0194&scoped=true&"
import script from "./ProductCombos.vue?vue&type=script&lang=js&"
export * from "./ProductCombos.vue?vue&type=script&lang=js&"
import style0 from "./ProductCombos.vue?vue&type=style&index=0&id=58ce0194&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce0194",
  null
  
)

export default component.exports